import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface exportDeviceDataGraphDataState {
  isLoading: boolean
  loadingError: string | null
  exportDeviceDataGraph: any
}

// Initial state of the slice
const initialState: exportDeviceDataGraphDataState = {
  isLoading: true,
  loadingError: null,
  exportDeviceDataGraph: null
}

// Slice to return from action
export const exportDeviceDataGraphDataSlice = createSlice({
  name: 'exportDeviceDataGraph',
  initialState,
  reducers: {
    exportDeviceDataGraphLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        exportDeviceDataGraph: []
      }
    },
    exportDeviceDataGraphUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        exportDeviceDataGraph: action.payload
      }
    },
    exportDeviceDataGraphErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        exportDeviceDataGraph: null
      }
    }
  }
})

// Actions to export
export const {
  exportDeviceDataGraphLoadingAction,
  exportDeviceDataGraphUpdateAction,
  exportDeviceDataGraphErrorAction
} = exportDeviceDataGraphDataSlice.actions

export default exportDeviceDataGraphDataSlice.reducer
